import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { EmployeeRoleCreateComponent } from '../../../features/employee/employee-role-create/employee-role-create.component'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import { EmployeeRoleEditComponent } from '../../../features/employee/employee-role-edit/employee-role-edit.component'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { MatButton } from '@angular/material/button'
import { EmployeeCreateComponent } from '../../../features/employee/employee-create/employee-create.component'
import { EmployeeEditComponent } from '../../../features/employee/employee-edit/employee-edit.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'employee',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    EmployeeRoleCreateComponent,
    FormSearchComponent,
    MatButton,
    FormClientSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss',
  providers: [EmployeeService, AuthService],
  standalone: true,
})
export class EmployeeComponent implements OnInit {
  constructor(
    private employeeService: EmployeeService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  // inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'roleEmployee',
      key: 'funcionarioFuncaoDescricao',
      description: 'Função',
    },
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'birth',
      key: 'dataNascimento',
      description: 'Nascimento',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'status_employee',
      key: 'statusFuncionarioDescricao',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    // {
    //   id: 'pessoaId',
    //   description: 'Pessoa Id',
    //   type: 'select',
    //   visible: false,
    // },
    // {
    //   id: 'funcionarioFuncaoId',
    //   description: 'Função Funcionário',
    //   type: 'select',
    //   visible: false,
    // },
    // {
    //   id: 'statusId',
    //   description: 'Status',
    //   type: 'select',
    //   visible: false,
    // },
    {
      id: 'nome',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'cpf',
      description: 'Cpf',
      type: 'string',
      visible: true,
    },
    {
      id: 'matricula',
      description: 'Matrícula',
      type: 'string',
      visible: true,
    },
    {
      id: 'email',
      description: 'Email',
      type: 'string',
      visible: true,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen: string = 'funcionário'
  // screen: string = 'função funcionário'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: false,
        // delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {
      pessoaId: 0,
      funcionarioFuncaoId: 0,
      statusId: 0,
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.employeeService.listPagedEmployee(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.employeeService
      .searchPagedEmployee(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(EmployeeCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(EmployeeEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
